import store from '@/store'
import {allowWarnings, nullString} from './utils'

// ---------------- Activities ---------------- //

export function getTaskDefaultActivity (task) {
  let ret = null
  try {
    ret = store.getters['activities/byId']({id: task.relationships.defaultActivity.data.id})
  } catch (e) { if (allowWarnings) console.warn(e) }
  return ret || {attributes: {name: nullString}}
}

// ---------------- Mapping ---------------- //

export function mapTasks (tasks) {
  tasks.map(task => {
    let project = task ? store.getters['projects/byId']({ id: task.relationships.project.data && task.relationships.project.data.id }) : null
    let client = task ? store.getters['clients/byId']({ id: task.relationships.client.data && task.relationships.client.data.id }) : null
    let defaultActivity = task ? store.getters['activities/byId']({ id: task.relationships.defaultActivity.data && task.relationships.defaultActivity.data.id }) : null
    let projectPath = task && task.attributes.path ? task.attributes.path.replace('|', ' | ') : '- - -'

    task.isPersonal = (task.attributes.tags || []).includes('FluxPersonal')
    task.project = project ? project.attributes.name : null
    task.projectPath = task.attributes.path ? task.attributes.path.replace(/\|/g, ' | ') : '- - -'
    task.client = client ? client.attributes.name : null
    task.defaultActivity = defaultActivity
    task.defaultActivityName = defaultActivity ? defaultActivity.attributes.name : '- - -'
    task.name = task.attributes.name
    task.priority = task.attributes.derivedPriority
    task.status = task.attributes.isDone ? 'Done' : task.attributes.isOnHold ? 'On Hold' : 'Active'
    task.taskString = `${client ? client.attributes.name : null} | ${project ? projectPath : null} | ${task ? task.attributes.name : null}`
    task.start = null
  })

  return tasks
}
